import { Button, Card } from "react-bootstrap"
import { useShoppingCart } from "../context/ShoppingCartContext"
import { formatCurrency } from "../functions/formatCurrency"
import {ButtonGroup} from "@mui/material";

// App.js
import React from "react";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

type StoreItemProps = {
  ID: number
  STOCKCODE: string
  DESCRIPTION: string
  DESCRIPTION2: string
  SELLPRICE: number
  STATE: string[]
}

export function Product({ ID, STOCKCODE, DESCRIPTION, SELLPRICE, DESCRIPTION2, STATE }: StoreItemProps) {

  const {
    getItemQuantity,
    increaseCartQuantity,
    decreaseCartQuantity,
    removeFromCart,
  } = useShoppingCart()

  const quantity = getItemQuantity(ID)
  return (
    <Card className="h-100">

      <Card.Img
        variant="top"
        src={"/assets/images/product/"+STOCKCODE+'.png'}

        className="img-fluid"
      />
      <Card.Body className="d-flex flex-column">

        <Card.Title className="d-flex justify-content-between align-items-baseline mb-2">
          <span className="fs-5">{DESCRIPTION}</span>
          <span className="ms-2 text-muted">{formatCurrency(SELLPRICE)}</span>
        </Card.Title>

        <small className="text-black-50 mb-2">Stockcode: {STOCKCODE}</small>

        <small className="text-black-50 mb-2">{DESCRIPTION2}</small>

        {STATE?.length > 0 && (
          <div className="mb-4">
            <small className="text-muted me-1">Available in:</small>
            {STATE.map(state => (
              <span key={state} className="badge bg-secondary me-1">{state.toUpperCase()}</span>
            ))}
          </div>
        )}

        <div className="mt-auto">
          {quantity === 0 ? (
            <Button className="w-100" onClick={() => increaseCartQuantity(ID)}>
              + Add To Cart
            </Button>
          ) : (
            <div
              className="d-flex align-items-center flex-column"
              style={{ gap: ".5rem" }}
            >
              <div className="d-flex align-items-center justify-content-center">

                <ButtonGroup>

                  <Button onClick={() => removeFromCart(ID)} variant="danger" size="sm">Remove</Button>&nbsp;&nbsp;&nbsp;

                  <Button style={{borderBottomRightRadius: '0', borderStartEndRadius: '0'}}
                          onClick={() => decreaseCartQuantity(ID)}
                  >
                    <RemoveIcon fontSize="small" />
                  </Button>

                  <div style={{minWidth: '50px', textAlign: 'center'}} className="fs-4 border">{quantity}</div>

                  <Button style={{borderBottomLeftRadius: '0', borderStartStartRadius: '0'}}
                          onClick={() => increaseCartQuantity(ID)}
                  >
                    <AddIcon fontSize="small" />
                  </Button>


                </ButtonGroup>

              </div>




            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  )
}